export const SET_LANGUAGE = "SET_LANGUAGE"; // action types

export function setLanguage(languageId: number) {
  return {
    type: SET_LANGUAGE,
    languageId
  };
}
